module.exports = __webpack_public_path__ + "img/76.e2e0df5.jpg";